import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Hidden,
  LinearProgress,
  SelectChangeEvent,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik, setNestedObjectValues } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
  AddDistributorRequestBody,
  DistributorListType,
  newRmType,
  NismDetailsType,
  RmsType,
} from '../../redux-store/types/api-types';
import { useDispatch } from 'react-redux';
import {
  addDistributor,
  editDistributor,
  getDistributorById,
  getNismData,
  getRMsList,
} from '../../redux-store/actions/userManagement';
import { DistributorSchema } from '../../utils/schema';
import MFSelectField from '../../lib/formik/SelectField';
import { Location } from 'history';
import { ConfirmationDialog } from '../commonComponents';
import { distributorMaster, DistributorTypesForUserManageMent } from '../../utils/constant';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import {
  arnCodeRegex,
  individualPanRegex,
  nonDigitRegex,
  nonIndividualPanRegex,
} from '../../utils/regex';
import { showError } from '../../redux-store/actions/auth';
import { isValidIndividualPan } from '../../utils/utilityFunctions';
import { LoadingButton } from '@mui/lab';
import { TextDatePicker } from '../../lib/DatePickerWithTextFeild';
import { useSnackbar } from 'notistack';
import { getStrategies } from '../../redux-store/actions/strategies';
import { GetStrategiesResponseBody } from '../../redux-store/types/strategies';

export default function AddDistributor({
  location,
}: {
  location: Location<{ typeOfDistributor: string; distributorId: number }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  //const [formikValues, setFormikValues] = useState<AddDistributorRequestBody | null>();
  const { typeOfDistributor, distributorId } = location.state || {};
  const [rmDropDownMaster, setRmDropDownMaster] = useState<RmsType[]>([]);
  const initialValues: AddDistributorRequestBody = {
    name: '',
    email: '',
    countryNameAndCode: 'India: +91',
    countryCode: '+91',
    phone: '',
    panNumber: '',
    certificateNumber: '',
    certificateValidFrom: null,
    certificateValidTo: null,
    certificateName: '',
    certificateCode: '',
    aprn: '',
    pincode: '',
    buildingNo: '',
    streetName: '',
    city: '',
    state: '',
    type: typeOfDistributor || '',
    country: '',
    isActive: true,
    rmId: null,
    distributorStrategies: [],
  };

  // useEffect(() => {
  //   let isComponentActive = true;
  //   (async function () {
  //     try {
  //       if (!formikValues) return;
  //       if (distributor) {
  //         await dispatch(editDistributor(id, formikValues));
  //       } else {
  //         await dispatch(addDistributor(formikValues));
  //       }

  //       if (!isComponentActive) return;
  //       history.push('distributors', { distributorType: formikValues.type });
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  //   return () => {
  //     isComponentActive = false;
  //   };
  // }, [formikValues]);
  const [distributorsAllStrategies, setDistributorStrategies] = useState<
    GetStrategiesResponseBody[]
  >([]);
  const [distributorDetails, setDistributorDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  // const [nismLoader, setNismLoader] = useState(false);
  // const [openForm, setOpenForm] = useState(false);
  const [dialogbox, setDialogBox] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        const res = (await dispatch(getRMsList({ isActive: true }))) as unknown as newRmType;
        const strategiesResponse = (await dispatch(
          getStrategies({
            isActive: true,
          })
        )) as unknown as GetStrategiesResponseBody[];
        setDistributorStrategies(strategiesResponse);
        setLoading(true);
        if (distributorId) {
          const getDistributorDetails = (await dispatch(
            getDistributorById(distributorId)
          )) as unknown as DistributorListType;
          const {
            name,
            panNumber,
            aprn,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            certificateNumber,
            certificateValidFrom,
            certificateValidTo,
            id,
            type,
            rmId,
            isActive,
            certificateName,
            certificateCode,
            strategies,
          } = getDistributorDetails;

          const { countryCode, countryNameAndCode, email, phone } = getDistributorDetails.user || {
            countryCode: '+91',
            countryNameAndCode: 'India: +91',
            email: '',
            phone: '',
          };
          setDistributorDetails({
            ...distributorDetails,
            name,
            panNumber,
            aprn,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            email,
            phone,
            id,
            type,
            rmId,
            isActive,
            countryNameAndCode: countryNameAndCode ? countryNameAndCode : 'India: +91',
            countryCode: countryCode ? countryCode : '+91',
            certificateNumber,
            certificateValidFrom,
            certificateValidTo,
            certificateName,
            certificateCode,
            distributorStrategies: strategies.map((strategy) => {
              return {
                id: strategy?.id as string,
                strategyId: strategy?.id as string,
              };
            }),
          });

          // setOpenForm(true);
        }
        if (!isComponentAlive) return;
        const { rms } = res || {};
        setRmDropDownMaster(rms);
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isComponentAlive = false;
    };
  }, []);

  // const handleNismDataFetch = async (
  //   values: AddDistributorRequestBody,
  //   setValues: (val: AddDistributorRequestBody) => void,
  //   validateForm: any,
  //   setErrors: any,
  //   setTouched: any
  // ) => {
  //   const formErrors = await validateForm();

  //   try {
  //     if (!values.panNumber || !isValidIndividualPan(values.panNumber)) {
  //       setTouched(setNestedObjectValues(formErrors, true));
  //       setErrors(formErrors);
  //       return;
  //     }

  //     setNismLoader(true);
  //     const nismData = (await dispatch(
  //       getNismData({ pan: values.panNumber })
  //     )) as unknown as NismDetailsType;
  //     const {
  //       certificateNumber,
  //       certificateValidTo,
  //       certificateValidFrom,
  //       candidateName,
  //       certificateName,
  //       certificateCode,
  //       mobileNumber,
  //     } = nismData;

  //     if (Object.keys(nismData).length === 0) {
  //       setValues({
  //         ...initialValues,
  //         distributorStrategies: values.distributorStrategies,
  //         panNumber: values.panNumber,
  //       });
  //       enqueueSnackbar('Data Not Found', {
  //         variant: 'error',
  //         autoHideDuration: 3000,
  //       });
  //     } else {
  //       setValues({
  //         ...values,
  //         ...initialValues,
  //         distributorStrategies: values.distributorStrategies,
  //         type: values.type,
  //         certificateNumber,
  //         certificateValidTo,
  //         certificateValidFrom,
  //         name: candidateName,
  //         phone: mobileNumber,
  //         panNumber: values.panNumber,
  //         certificateName,
  //         certificateCode,
  //       });
  //       enqueueSnackbar('Data Fetched Successfully', {
  //         variant: 'success',
  //         autoHideDuration: 3000,
  //       });
  //     }

  //     setOpenForm(true);
  //   } catch (e) {
  //     typeof e === 'string' && dispatch(showError(e));
  //     console.error((e as Error).message);
  //   } finally {
  //     setNismLoader(false);
  //   }
  // };

  const onSubmit = async (values: AddDistributorRequestBody) => {
    try {
      if (distributorId) {
        await dispatch(
          editDistributor(distributorId, {
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
            strategyIds: values.distributorStrategies.map(
              (strategies) => strategies.strategyId
            ) as string[],
          })
        );
        history.push('distributor-details', { distributorType: values.type, distributorId });
      } else {
        await dispatch(
          addDistributor({
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
            strategyIds: values.distributorStrategies.map(
              (strategies) => strategies.strategyId
            ) as string[],
          })
        );
        history.push('distributors', { distributorType: values.type });
      }
    } catch (e) {
      console.error((e as Error).message);
    }
    //setFormikValues({ ...values, countryCode: values.countryNameAndCode?.split(':')[1].trim() });
  };

  return (
    <>
      <Formik
        initialValues={distributorDetails}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={DistributorSchema}>
        {({
          handleSubmit,
          values,
          setFieldValue,
          setValues,
          validateForm,
          setErrors,
          setTouched,
          resetForm,
        }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    distributorId
                      ? history.push(`distributor-details`, {
                          distributorType: values.type,
                          distributorId,
                        })
                      : history.push('distributors', { distributorType: values.type })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  User Management
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    distributorId
                      ? history.push(`distributor-details`, {
                          distributorType: values.type,
                          distributorId,
                        })
                      : history.push('distributors', { distributorType: values.type })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                  textTransform: 'capitalize',
                }}>
                {typeOfDistributor
                  ? 'Onboarding Distributor Details'
                  : `${values.type} Distributor Detail`}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress />
            ) : (
              <>
                <>
                  {typeOfDistributor && (
                    <>
                      <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFSelectField
                            name="type"
                            items={Object.keys(DistributorTypesForUserManageMent).map((_ele) => ({
                              key: _ele,
                              value: DistributorTypesForUserManageMent[_ele],
                            }))}
                            label="Distributor Type *"
                            onChange={({ target: { value } }: SelectChangeEvent<unknown>) => {
                              resetForm();
                              setValues({
                                ...values,
                                ...initialValues,
                                type: value as unknown as string,
                              });
                              // setOpenForm(false);
                            }}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {/* {values.type === DistributorTypesForUserManageMent.Individual && (
                    <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                      <Grid item xs={12} sm={6} md={4}>
                        <MFTextField
                          name="panNumber"
                          label="Pan *"
                          placeholder="Enter Pan"
                          inputProps={{ style: { textTransform: 'uppercase' } }}
                          onChange={(e) => {
                            openForm && setOpenForm(false);
                            setFieldValue('panNumber', e.target.value.toUpperCase());
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <LoadingButton
                          disabled={openForm}
                          onClick={() =>
                            handleNismDataFetch(
                              values,
                              setValues,
                              validateForm,
                              setErrors,
                              setTouched
                            )
                          }
                          loadingPosition="start"
                          loading={nismLoader}
                          variant="contained"
                          sx={{
                            mt: 3,
                            mb: 2,
                            color: 'common.white',
                            lineHeight: 1.5,
                            fontSize: 14,
                            position: 'relative',
                            top: '1.5rem',
                            width: '10rem',
                          }}>
                          Fetch Data
                        </LoadingButton>
                      </Grid>
                    </Grid>
                  )} */}
                  {(values.type === DistributorTypesForUserManageMent.Company ||
                    values.type === DistributorTypesForUserManageMent.Individual) && (
                    <>
                      <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="name"
                            label="Distributor Name *"
                            placeholder="Enter Distributor Name"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="panNumber"
                            label={`${
                              values.type === DistributorTypesForUserManageMent.Company
                                ? 'Pan *'
                                : 'Pan'
                            }`}
                            placeholder="Enter Pan"
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                            onChange={(e) => {
                              setFieldValue('panNumber', e.target.value.toUpperCase());
                            }}
                          />
                        </Grid>

                        {values.type === 'individual' && (
                          <>
                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name="email"
                                label="Email Id *"
                                placeholder="Enter Email Id"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                name="phone"
                                label="Mobile Number *"
                                placeholder="Enter Mobile Number"
                                // startAdornment={
                                //   <CountryCodesDropDown
                                //     name={`countryNameAndCode`}
                                //     value={values.countryNameAndCode}
                                //   />
                                // }
                                regexForFilterValue={nonDigitRegex}
                              />
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="aprn"
                            label="APRN Code *"
                            placeholder="Enter APRN Code"
                            inputProps={{ style: { textTransform: 'uppercase' } }}
                            onChange={(e) => {
                              setFieldValue('aprn', e.target.value.toUpperCase());
                            }}
                          />
                        </Grid>
                        {values.type === 'individual' && (
                          <>
                            <Grid item xs={12} sm={6} md={4}>
                              <MFTextField
                                // disabled={true}
                                name="certificateNumber"
                                label="NISM XXIA Registration No. *"
                                placeholder="Enter NISM XXIA Registration No."
                              />
                            </Grid>{' '}
                            <Grid item xs={12} sm={6} md={4}>
                              <TextDatePicker
                                label={'NISM XXIA Registration Date *'}
                                inputLabelStyles={{
                                  transform: 'unset',
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: 'rgba(0,0,0,0.7)',
                                }}
                                placeholder={'Enter NISM XXIA Registration Date'}
                                name={`certificateValidFrom`}
                                // disabled={true}
                              />
                            </Grid>{' '}
                            <Grid item xs={12} sm={6} md={4}>
                              <TextDatePicker
                                label={'NISM XXIA Expiry Date *'}
                                inputLabelStyles={{
                                  transform: 'unset',
                                  fontSize: 14,
                                  fontWeight: 500,
                                  color: 'rgba(0,0,0,0.7)',
                                }}
                                placeholder={'Enter NISM XXIA Expiry Date'}
                                name={`certificateValidTo`}
                                maxDate={
                                  new Date(new Date().setFullYear(new Date().getFullYear() + 120))
                                }
                                minDate={new Date(new Date().setDate(new Date().getDate()))}
                                // disabled={true}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={4}>
                              {/* <MFTextField name="rmName" label="RM Name" placeholder="Enter RM Name" /> */}
                              <SearchableSelect
                                name="rmId"
                                label="RM Name *"
                                items={rmDropDownMaster
                                  .sort((rm1, rm2) =>
                                    (rm1['name'] || '')
                                      .toString()
                                      .localeCompare((rm2['name'] || '').toString())
                                  )
                                  .map((item) => ({
                                    key: item.name,
                                    value: item.id,
                                  }))}
                                searchFieldPlaceholder={'Search RM'}
                              />
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField name="pincode" label="Pincode" placeholder="Enter Pincode" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="buildingNo"
                            label="Building Number"
                            placeholder="Enter Building Number"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField
                            name="streetName"
                            label="Street Name"
                            placeholder="Enter Street Name"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField name="state" label="State" placeholder="Enter State" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField name="city" label="City" placeholder="Enter City" />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <MFTextField name="country" label="Country" placeholder="Enter Country" />
                        </Grid>
                      </Grid>
                      {/* {values.distributorStrategies.map((strategy, index) => {
                        return (
                          <Grid
                            key={index}
                            container
                            rowSpacing={1}
                            columnSpacing={4}
                            px={4}
                            pt={3}>
                            <Grid item xs={12} sm={6} md={4}>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between">
                                <MFSelectField
                                  name={`distributorStrategies.${index}.strategyId`}
                                  items={distributorsAllStrategies.map((item) => ({
                                    key: item.strategyName as string,
                                    value: item.id as string,
                                  }))}
                                  label="Distributor Strategies *"
                                />
                                <IconButton
                                  onClick={() => {
                                    setDeleteId(strategy?.id as string);
                                    setDialogBox(true);
                                  }}
                                  sx={{ position: 'relative', top: '0.8rem', ml: '0.5rem' }}>
                                  <DeleteOutlineIcon
                                    titleAccess="Delete Form"
                                    sx={{ cursor: 'pointer' }}
                                    color="error"
                                    fontSize="small"
                                  />
                                </IconButton>
                              </Box>
                            </Grid>
                          </Grid>
                        );
                      })} */}
                      {/* <Grid container rowSpacing={1} columnSpacing={4} px={4} pt={3}>
                        <Grid item xs={12} sm={6} md={4}>
                          <Button
                            variant="outlined"
                            startIcon={<AddIcon />}
                            sx={{
                              color: 'primary.main',
                              fontWeight: 500,
                              fontSize: 14,
                              mr: 2.5,
                              py: 0.5,
                              px: 3,
                            }}
                            onClick={() =>
                              setValues({
                                ...values,
                                distributorStrategies: [
                                  ...values.distributorStrategies,
                                  {
                                    id: Date.now().toString(),
                                    strategyId: '',
                                  },
                                ],
                              })
                            }>
                            Add Strategy
                          </Button>
                        </Grid>
                      </Grid> */}
                      <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                        <MFSubmitButton label="Save" />
                      </Box>
                      <ConfirmationDialog
                        message={`Are you sure you want to delete the strategy ?`}
                        open={dialogbox}
                        setOpen={() => setDialogBox(true)}
                        onSave={() => {
                          setValues({
                            ...values,
                            distributorStrategies: values.distributorStrategies.filter((value) => {
                              return deleteId !== value.id;
                            }),
                          });
                          setDialogBox(false);
                        }}
                        onCancel={() => setDialogBox(false)}
                      />
                    </>
                  )}
                </>
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
